export const FLAG_WEB_TERMINAL = 'WEB_TERMINAL';
export const DEFAULT_NS_OPERATORS = 'openshift-operators';
export const FLAG_DEVWORKSPACE = 'DEVWORKSPACE';
export const FLAG_V1ALPHA2DEVWORKSPACE = 'v1alpha2DEVWORKSPACE';
